var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2783 17.633L24.1803 12.603H18.5338V9.33945C18.5338 7.96453 19.3211 6.62145 21.8524 6.62145H24.421V2.34005C24.421 2.34005 22.0902 2 19.8624 2C15.2123 2 12.1714 4.40738 12.1714 8.76944V12.6031H7V17.6331H12.1714V29.7897C13.2079 29.929 14.2702 30 15.3526 30C16.4349 30 17.4973 29.9266 18.5338 29.7897V17.6331H23.2785L23.2783 17.633Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.45c6996aa152cae7a8cd34e94fbae08e.svg";
export { ForwardRef as ReactComponent };